import { Outlet, useParams } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { InboxPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import MessageList from 'modules/finance/components/MessageList'
import CopyButton from 'modules/finance/public/CopyButton'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const InboxPage = () => {
  const params = useParams()
  const messageId = Number(params.messageId)

  const { loading, data, error } = useQuery(InboxPageDocument)

  const email = data?.finance.inboxesConnection.nodes[0]?.email
  const canCreatePurchaseFinancialDocuments =
    data?.finance?._policies?.financialDocumentsCreatePurchase?.can ?? false

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      authorized={canCreatePurchaseFinancialDocuments}
    >
      <Box flexDirection="row" alignItems="center" gap="s8" paddingBottom="s16">
        {email && (
          <>
            <Text.Normal color="grey800">{email}</Text.Normal>
            <CopyButton target={email} />
          </>
        )}
      </Box>
      <Box
        flexGrow
        maxHeight="full-view-height"
        flexDirection="row"
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
      >
        <MessageList />
        <Box alignItems="center" height="full-view-height" flexGrow overflowX="hidden">
          <Outlet context={{ messageId }} />
        </Box>
      </Box>
    </ResponsivePage.Body>
  )
}

export default InboxPage
